export default {
  label: 'labelledElement-label',
  childrenWrapper: 'labelledElement-children',
};
